import { render, staticRenderFns } from "./PayoutRequestsView.vue?vue&type=template&id=3c1f4378&scoped=true&"
import script from "./PayoutRequestsView.vue?vue&type=script&lang=ts&"
export * from "./PayoutRequestsView.vue?vue&type=script&lang=ts&"
import style0 from "./PayoutRequestsView.vue?vue&type=style&index=0&id=3c1f4378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1f4378",
  null
  
)

export default component.exports